import { useFilterValue } from '@btime/react-contexts'
import React from 'react'

import { useFilterValueText } from '../../../utils/helpers/filters'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import Link from '../../../packages/kiti/components/actions/Link'
import ProfilesFilterSideModal from './ProfilesFilterSideModal'

const ProfilesFilter = ({ label, field, icon, presentation, ...props }) => {
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  label = label || 'Perfil'
  field = field || 'profileIds'
  const value = useFilterValue(field, [])

  const selectedValue = useFilterValueText(field)
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && 'RiPriceTag3Line'}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <ProfilesFilterSideModal open={open} onClose={() => setOpen(false)} label={label} field={field} {...props} />
    </>
  )
}

export default ProfilesFilter
